module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_2-b606bb8bf5e28b2d038a14ac05721263.png";